import React from "react";
import {
  BrowserRouter,
  Navigate,
  Routes,
  Route,
} from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Helmet, HelmetProvider } from "react-helmet-async";

import { siteConstants } from "./constants";
import { GlobalStyle } from "./components/styles";
import HomePage from "./components/pages/HomePage";
import Tinder from "./components/pages/Tinder";
import theme from "./theme";
import "./App.css";

const App = () => {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyle />
        <Helmet
          defaultTitle={ siteConstants.DEFAULT_TITLE }
          titleTemplate={ siteConstants.TITLE_TEMPLATE }
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/areyoucompatible" element={<Tinder />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
